import React from 'react'; 

import DropDown from '../DropDown';
import SelectGroup from '../SelectGroup';
import USDatePicker from '../USDatePicker';
import moment from 'moment';

const renderFilter = (setting, props) => {
  const { reportTypes, widget, setWidgetFieldValueWrapper, formTypes } = props;
  let periods = props.periods;

  if(widget.widgetType === "saleCall" ) {
    periods = periods && periods.length ? periods.filter(p => p.value === 'today' || p.value === 'currentWeek') : [];
  }

  switch (setting) {
    case 'period': {
      return (
        <div>
          <DropDown
            setWidgetFieldValue={setWidgetFieldValueWrapper}
            field={'dataConfig.period'}
            options={periods}
            widget={widget}
          />
          {widget.dataConfig.period === 'custom' ?
          <div>
            <h5>Startdatum</h5>
            <USDatePicker
                widget={widget}
                field={'dataConfig.startDate'}
                setWidgetFieldValue={setWidgetFieldValueWrapper}
                placeholderText="Startdatum"
            />
            <h5>Slutdatum</h5>
            <USDatePicker
                widget={widget}
                field={'dataConfig.endDate'}
                setWidgetFieldValue={setWidgetFieldValueWrapper}
                placeholderText="Slutdatum"
                minDate={moment(_.get(widget, 'dataConfig.startDate'))}
            />
          </div> : ''}
        </div>);
    }
    case 'pastPeriod': {
      return (
        <div>
          <DropDown
            setWidgetFieldValue={setWidgetFieldValueWrapper}
            field={'dataConfig.period'}
            options={_.filter(periods, (p) => !_.includes(['nextWeek'], p.value))}
            widget={widget}
          />
          {widget.dataConfig.period === 'custom' ?
          <div>
            <h5>Startdatum</h5>
            <USDatePicker
                widget={widget}
                field={'dataConfig.startDate'}
                setWidgetFieldValue={setWidgetFieldValueWrapper}
                placeholderText="Startdatum"
            />
            <h5>Slutdatum</h5>
            <USDatePicker
                widget={widget}
                field={'dataConfig.endDate'}
                setWidgetFieldValue={setWidgetFieldValueWrapper}
                placeholderText="Slutdatum"
            />
          </div> : ''}
        </div>);
    }
    case 'users': {
      return (
        <SelectGroup
          title="Användare"
          label="name"
          placeholder="Samtliga"
          endpoint="user"
          group="role.name"
          field="dataConfig.include.user"
          setWidgetFieldValue={setWidgetFieldValueWrapper}
          widget={widget}
        />
      );
    }
    case 'formType': {
      return (
        <DropDown
        field={'dataConfig.form.type'}
        options={formTypes}
        setWidgetFieldValue={setWidgetFieldValueWrapper}
        widget={widget}
      />)
    }
  }
}

const titleMap = {
  period: 'Period',
  pastPeriod: 'Period',
  users: 'Användare',
  formType: 'Typ',
};

const WidgetFilters = (props) => {
  const { reportTypes, widget } = props;

  const widgetType = _.find(_.get(reportTypes, [widget.widgetType]), {value: widget.dataType});
  return (
    <div>
      {_.map(widgetType.filters, (setting, index) => {
        return (
          <div className="col-100-percent" key={`setting-component-${index}-${setting}`}>
            <div className="helper">
              <span className="title">{titleMap[setting]}</span>
              <div>
                {renderFilter(setting, props)}
              </div>
            </div>
          </div>
        )
      })}
    </div>)
};
 
WidgetFilters.propTypes = { 
  widget: React.PropTypes.object,
  reportTypes: React.PropTypes.object,
  setWidgetFieldValueWrapper: React.PropTypes.func,
}; 
 
export default WidgetFilters; 



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/WidgetSettings/WidgetFilters.jsx
 **/